import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Table, Button, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { quotationAPI } from '../../services/api';

const QuotationHistory = () => {
  const [quotations, setQuotations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchQuotations();
  }, []);

  const fetchQuotations = async () => {
    try {
      const response = await quotationAPI.getAll();
      setQuotations(response.data);
    } catch (error) {
      console.error('Error fetching quotations:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadPDF = async (id, projectTitle) => {
    try {
      const response = await quotationAPI.downloadPDF(id);
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', );
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Error downloading PDF:', error);
      alert('Failed to download PDF');
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(amount);
  };

  if (loading) {
    return (
      <div className="loading-spinner">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <Container fluid className="p-4">
      <Row className="mb-4 align-items-center">
        <Col>
          <h2 className="mb-0">
            <i className="bi bi-receipt me-2"></i>
            Quotation History
          </h2>
        </Col>
        <Col className="text-end">
          <Button as={Link} to="/quotations/generate" variant="primary">
            <i className="bi bi-plus-lg me-2"></i>
            Generate New
          </Button>
        </Col>
      </Row>

      <Card>
        <Card.Body className="p-0">
          <Table responsive hover className="mb-0">
            <thead className="table-dark">
              <tr>
                <th>Quotation #</th>
                <th>Project Title</th>
                <th>Client</th>
                <th>Grand Total</th>
                <th>Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {quotations.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center text-muted py-4">
                    No quotations found
                  </td>
                </tr>
              ) : (
                quotations.map((quotation) => (
                  <tr key={quotation._id}>
                    <td>
                      <Badge bg="secondary">{quotation.quotationNo}</Badge>
                    </td>
                    <td>{quotation.projectTitle}</td>
                    <td>{quotation.clientId?.clientName || 'N/A'}</td>
                    <td>
                      <Badge bg="success">
                        {formatCurrency(quotation.grandTotal)}
                      </Badge>
                    </td>
                    <td>{formatDate(quotation.createdAt)}</td>
                    <td className="table-actions">
                      <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => handleDownloadPDF(quotation._id, quotation.projectTitle)}
                        title="Download PDF"
                      >
                        <i className="bi bi-download"></i>
                      </Button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default QuotationHistory;
